module.exports = __webpack_public_path__ + "img/alg3.d2af76f1.png";